import { api } from 'api'
import { z } from 'zod'

const pulsePositionTypesResponse = z.object({
  position_types: z.array(z.string()),
})

export type PulsePositionTypes = z.infer<typeof pulsePositionTypesResponse>

export async function getPulsePositionTypes(
  companyIds: number[],
  signal?: AbortSignal
) {
  return await api
    .get('/company/pulse/position_types', {
      params: { company_ids: companyIds },
      signal,
    })
    .then((response) => response.data)
    .then(pulsePositionTypesResponse.parse)
}
